import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FieldFormComponent } from '../field-form/fieldform.component';


@Component({
    selector: 'm4u-fielddetailx',
    templateUrl: './fielddetailx.component.html',
    styleUrls: ['./fielddetailx.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldDetailComponentX extends FieldFormComponent {
    @Input() Icon: string;
    @Input() IsShowEmpty: boolean;
    @Input() Position: 'vertical' | 'horizontal' = 'vertical';
    @Input() ValueAlignment: 'start' | 'end' = 'start';
    @Input() Class: string;
    // obsolete
    @Input() Value: string;
}